
(function(){
  const CARD = '.header__dropdown__image.section--image';
  const DROPDOWN = '.header__dropdown';

  // Tiny safety shims
  (function(w){
    if (!w.Element) return;
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
    }
    if (!Element.prototype.closest) {
      Element.prototype.closest = function(sel){
        let el = this;
        while (el && el.nodeType === 1) {
          if (el.matches(sel)) return el;
          el = el.parentElement || el.parentNode;
        }
        return null;
      };
    }
  })(window);

  const isEl = n => n && n.nodeType === 1;
  const isVisible = el => isEl(el) && el.offsetParent !== null && getComputedStyle(el).visibility !== 'hidden';

  function whenImagesReady(roots){
    const imgs = roots.flatMap(r => Array.from(r.querySelectorAll('img')));
    if (!imgs.length) return Promise.resolve();
    return Promise.all(imgs.map(img => img.complete
      ? Promise.resolve()
      : new Promise(res => img.addEventListener('load', res, {once:true}))
    ));
  }

  function equalize(cards){
    cards = cards.filter(isVisible);
    if (cards.length < 2) return;

    // reset first
    cards.forEach(c => c.style.minHeight = '');

    // group by row using top offset (rounded to smooth sub-px differences)
    const rows = new Map();
    const baseTop = cards[0].getBoundingClientRect().top; // stable anchor
    cards.forEach(c => {
      const key = Math.round((c.getBoundingClientRect().top - baseTop) / 2) * 2;
      (rows.get(key) || rows.set(key, []).get(key)).push(c);
    });

    rows.forEach(row => {
      const max = Math.max(...row.map(el => el.offsetHeight));
      row.forEach(el => el.style.minHeight = max + 'px');
    });
  }

  // Equalize the PAGE grid (cards NOT inside dropdowns)
  function runPage(){
    const pageCards = Array
      .from(document.querySelectorAll(CARD))
      .filter(c => !c.closest(DROPDOWN) && isVisible(c));
    if (!pageCards.length) return;
    whenImagesReady(pageCards).then(() => equalize(pageCards));
  }

  // Equalize each visible DROPDOWN independently
  function runDropdowns(){
    document.querySelectorAll(DROPDOWN).forEach(dd => {
      const cards = Array.from(dd.querySelectorAll(CARD)).filter(isVisible);
      if (!cards.length) return;
      whenImagesReady(cards).then(() => equalize(cards));
    });
  }

  // small debounce helper
  const deb = (fn => { let t; return () => { clearTimeout(t); t = setTimeout(fn, 90); }; });

  const debRunPage = deb(runPage);
  const debRunDropdowns = deb(runDropdowns);

  // Initial + lifecycle hooks
  document.addEventListener('DOMContentLoaded', runPage);
  window.addEventListener('load', () => { runPage(); runDropdowns(); });
  window.addEventListener('resize', () => { debRunPage(); debRunDropdowns(); });

  // Fire when dropdowns open (hover/focus) — guard non-element targets
  document.addEventListener('mouseover', e => {
    const t = e.target; if (!isEl(t)) return;
    if (t.closest(DROPDOWN) || t.closest('[data-hover-disclosure]')) debRunDropdowns();
  });
  document.addEventListener('focusin', e => {
    const t = e.target; if (!isEl(t)) return;
    if (t.closest(DROPDOWN) || t.closest('[data-hover-disclosure]')) debRunDropdowns();
  });

  // Theme/Shopify updates
  document.addEventListener('shopify:section:load', () => { runPage(); runDropdowns(); });
  document.addEventListener('shopify:section:render', () => { runPage(); runDropdowns(); });

  // React to any class/style flips that reveal/hide dropdowns
  new MutationObserver(() => { debRunPage(); debRunDropdowns(); })
    .observe(document.body, {subtree:true, attributes:true, attributeFilter:['class','style']});

  // Debug helper: type window.__eqDebug() in console
  window.__eqDebug = function(){
    const all = document.querySelectorAll(CARD).length;
    const page = Array.from(document.querySelectorAll(CARD)).filter(c => !c.closest(DROPDOWN)).length;
    const drop = all - page;
    console.log({all, page, drop});
  };
})();